export default __webpack_public_path__ + "static/media/premium-exercise-tags.6a7cc71a.jpg";